import React from 'react';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import { convertToDate } from "examsbook-react-sdk/common";

/**
 * LiveTestContent
 * @param props
 * @returns {*}
 * @constructor
 */
const LiveTestContent = props => {
    const { testData, mobile, t } = props;
    return (
        <>
            <div className="title">
                {!mobile ?
                    <Tooltip placement="top-start" title={testData.name} aria-label={testData.name}>
                        <h4 className="tool-tip">{testData.name}</h4></Tooltip> :
                    <h4 className="tool-tip">{testData.name}</h4>
                }
            </div>

            <div className="live-test-time">
                <span>{t("LIVE_FROM")} : {testData.startDate ? convertToDate(testData.startDate) : null}</span>
                <span>{t("EXPIRES_ON")} : {testData.endDate ? convertToDate(testData.endDate) : null}</span>
            </div>
        </>
    );
};

export default LiveTestContent;
